/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.2",
    versionName: "0.4.0-nightly.2026.7.2",
    versionChannel: "nightly",
    buildDate: "2026-07-02T00:38:15.262Z",
    commitHash: "ae2674437999c34dfde3bac6268f691207b51ecb",
};
